import {getApp} from "@/appsManager/helpers"
import React from "react";
import ReactDOM from 'react-dom/client';
import PageManager from "@/commons/loadingPage/PageManager";
import {InfoBox} from "@/commons/infoBox/InfoBox";
import ContextManager from "@/contexts/ContextManager";
import './index.css'
import Cookies from "@/commons/polices/cookies/Cookies";

const root = ReactDOM.createRoot(document.getElementById('root'));
document.title = "EBLCraft";
let CurrentApp = getApp();

root.render(
    <>
        <div>
            <ContextManager>
                <PageManager/>
                <InfoBox/>
                <CurrentApp/>
                <Cookies/>
            </ContextManager>
        </div>
    </>);